// EvSenaryosuKart — Anne Defteri'nde "Ev şu an satılırsa senin hissen %20"
// kartı. Hafif accent glow ile öne çıkar.
//
// Sketch'te .ev-card sınıfı var (linear gradient + accent shadow);
// styles.css'e ekleniyor.

import { fmtTLCompact } from "../lib/format";

interface Props {
  sharePct: number; // 0..1
  shareTl: number;
  targetTl: number;
}

export default function EvSenaryosuKart({ sharePct, shareTl, targetTl }: Props) {
  // < 0.5% durumunda %0 yuvarlama kafa karıştırıcı — virgül göster.
  const pct = sharePct * 100;
  const pctLabel = pct < 1 ? `%${pct.toFixed(1).replace(".", ",")}` : `%${pct.toFixed(0)}`;
  return (
    <article className="ev-card rounded-2xl p-4">
      <header className="flex items-center gap-2 mb-2">
        <span className="w-2 h-2 rounded-full bg-accent-400" aria-hidden="true" />
        <h3 className="text-[10px] uppercase tracking-wider text-accent-300 font-semibold">
          Ev senaryosu
        </h3>
        <span className="ml-auto text-[10px] text-ink-400">
          bugünkü piyasaya göre
        </span>
      </header>

      <p className="hedef-dili text-ink-100 text-base leading-snug">
        Ev şu an satılırsa senin hissen:
      </p>
      <p className="anne-hero text-accent-300 text-5xl leading-none font-semibold mt-3">
        {pctLabel}
      </p>
      <p className="hedef-dili text-ink-200 text-sm mt-3 leading-snug">
        {fmtTLCompact(targetTl)} üzerinden{" "}
        <span className="not-italic fon-dili text-accent-300 whitespace-nowrap">
          {fmtTLCompact(shareTl)}
        </span>{" "}
        eder.
      </p>
    </article>
  );
}
